export default [
  {
    hid: 'image',
    name: 'image',
    property: 'og:image',
    content: 'https://campsite.bio/og-open-graph.jpg',
  },
  {
    hid: 'twitter:image',
    name: 'twitter:image',
    content: 'https://campsite.bio/og-open-graph.jpg',
  },
  {
    hid: 'og:image:height',
    name: 'og:image:height',
    property: 'og:image:height',
    content: '630',
  },
  {
    hid: 'og:image:width',
    name: 'og:image:width',
    property: 'og:image:width',
    content: '1200',
  },
];
